import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import LandingPage from './pages/LandingPage';
import ReferencesPage from './pages/ReferencesPage';
import './App.css';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/referenzen" element={<ReferencesPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;